import React, { PureComponent } from 'react';
import { compose, withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { courseOutlineConfig as courseOutlineConfigActions } from 'legacy/packages/unit-outline/src/actions';
import { getCourseOutlineConfig } from 'legacy/packages/unit-outline/src/queries';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { unitsClient } from 'legacy-src/utility/GraphqlClients';
import log from 'chameleon/ui-stack/utilities/log';

const { saveCourseOutlineConfig: saveCourseOutlineConfigAction } =
  courseOutlineConfigActions;

/**
 * Provides course outline config
 * @dreprecated - all usages must refactor and use chameleon/packages/units/composable/withCourseOutlineConfig.js
 * */
const CourseOutlineConfig = (WrappedComponent) => {
  class Config extends PureComponent {
    static displayName = 'CourseOutlineConfig';

    constructor(props) {
      super(props);

      const {
        courseOutlineConfig,
        params: { subject },
      } = props;
      this.state = {
        loading: courseOutlineConfig.subjectId !== subject,
      };

      this.getCourseOutlineConfig = this.getCourseOutlineConfig.bind(this);
      this.queryCourseOutlineConfig = this.queryCourseOutlineConfig.bind(this);
    }

    componentDidMount() {
      this.getCourseOutlineConfig(this.props);
    }

    componentDidUpdate(prevProps) {
      if (
        this.props.params.subject !== prevProps.params.subject ||
        (this.props.educationPeriod &&
          this.props.educationPeriod !== prevProps.educationPeriod)
      ) {
        this.getCourseOutlineConfig(this.props);
      }
    }

    /**
     * Get Course Outline configuration
     * @param {object} props
     * */
    getCourseOutlineConfig(props) {
      const {
        courseOutlineConfig,
        params: { subject },
        educationPeriod,
      } = props;

      if (courseOutlineConfig.subjectId !== subject) {
        this.queryCourseOutlineConfig(subject, educationPeriod);
      }
    }

    /**
     * Query for new Course Outline config
     * @param {string} subjectId
     * @param {string} educationPeriod
     * */
    queryCourseOutlineConfig(subjectId, educationPeriod) {
      const { saveCourseOutlineConfig } = this.props;
      this.setState(
        {
          loading: true,
        },
        () => {
          unitsClient
            .query({
              query: getCourseOutlineConfig,
              variables: {
                subjectId,
                educationPeriod,
              },
            })
            .then((resp) => {
              const data = resp.data || {};
              saveCourseOutlineConfig({
                subjectId,
                data: data.courseOutlineConfig || {},
              });
              this.setState({
                loading: false,
              });
            })
            .catch((error) => {
              log('error', error);
              /**
               * Reset the config if it's not available
               * */
              saveCourseOutlineConfig({
                subjectId,
                data: {},
              });
              this.setState({
                loading: false,
              });
            });
        },
      );
    }

    render() {
      if (this.state.loading) {
        return (
          <LoadingSpinner
            containerClassName="course-outline-config-spinner"
            data-test-course-outline-config-loading
          />
        );
      }

      return <WrappedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    const { courseOutlineConfig } = state.units;
    const { chosenEducationPeriodCode } = state.userData;

    return {
      courseOutlineConfig,
      educationPeriod: chosenEducationPeriodCode,
    };
  }

  return compose(
    withRouter,
    withApollo,
    connect(mapStateToProps, {
      saveCourseOutlineConfig: saveCourseOutlineConfigAction,
    }),
  )(Config);
};

export default CourseOutlineConfig;
